<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('SuccessfulPayments')" class="mt-2">
            <SuccessfulPayment></SuccessfulPayment>
          </vs-tab>
          <vs-tab :label="$t('UnsuccessfulPayments')" class="mt-2">
            <RejectPayment></RejectPayment>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import SuccessfulPayment from "./SuccessfulPayment.vue";
import RejectPayment from "./RejectPayment.vue";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
export default {
  name: "FinicialManagement_BankPortalPayments_Index",
  components: {
    SuccessfulPayment,
    RejectPayment
  }
};
</script>
